import { Button, Card, ConfirmModal, Loader, Typography } from 'src/components/common';
import {
  demoDayRocket, ventureverselightning,
  usernew,
  flashicon,
  briefcase,
  venturechat
} from 'src/assets/images';
import cx from './banner.module.scss';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { TCreateMVPRequest } from 'src/services/apiEndpoint.types.ts/ideaHub/createIdea.endpoint.types';
import { createMVP } from 'src/store/ideaHub/createMVP.thunk';
import { useGetIdentity } from 'src/hooks';
// import { createMVP } from 'src/store/ideaHub/ideaHub.slice';

function DemoDayBanner({ isCreation = false }: { isCreation?: boolean }) {
  // hooks 
  const navigate = useNavigate();
  const dispatch = useAppDispatch()
  const { getIdentities } = useGetIdentity();
    const { loggedInUserType } = getIdentities();
  const { myVenture, counters, loading } = useAppSelector(
    (store) => store.venture
  );
  const isAuthorized: boolean = useAppSelector((store) => store.auth.isAuthorized);
  const { profile } = useAppSelector((store) => store.profile);
  const { myCompany } = useAppSelector((store) => store.company);
  const email = loggedInUserType === 'User' ? profile?.email : myCompany?.email;
  const userType = loggedInUserType;
  // state 
  const [show, setShow] = useState<boolean>(false);
  const [visibleSide, setVisibleSide] = useState<number>(0)
  const [mvpLoading, setMvpLoading] = useState<string>('')

  // constant 
  const totalVentures = counters.ventures;
  const totalSeekingCoFounder = counters.seekingCoFounders;
  const totalHiringTeams = counters.hiringTeams;
  const totalFeedback = counters.comments;
  // handler
  function handleNavigate() {
    navigate(`/login?prev=${encodeURIComponent('/venture')}`)
  }

  function handleNavigateToDemoDay() {
    navigate('/demo-day')
  }

  const handleCreate = () => {
    if (!isAuthorized) {
      setShow(true)
      return
    }
    if (!myVenture) {
      navigate('/post-venture')
      return
    }
    let path = '';
    if (myVenture?.draft) {
      path = `/post-venture?id=${myVenture.id}&type=draft`
    } else if (!myVenture?.draft) {
      path = `/my-venture?id=${myVenture?.id}`;
    }
    navigate(path)
  }

  function handleNavigateToMVP(type: string) {
    if (!isAuthorized) {
      setShow(true)
      return
    }
    const payload: TCreateMVPRequest = {
      email,
      userType
    }
    setMvpLoading(type)
    dispatch(createMVP(payload)).then((response: any) => {
      console.log(response, 'tokenREsponse');
      if (response?.data?.data?.tokenUrl) {
        window.open(response?.data?.data?.tokenUrl)
      }
      setMvpLoading('')
    }).finally(() => {
      setMvpLoading('')
    })
  }

  useEffect(() => {
    if (!isCreation) {
      const interval = setInterval(() => {
        // setVisibleSide((prev: number) => prev === 0 ? 1 : 0)
        setVisibleSide((prev: number) => 1)
      }, 6000)
      return () => {
        clearInterval(interval)
      }
    }
  }, [isCreation])
  return (
    <>
      <div className="row g-3 h-auto">
        <div className={`col-xl-${isCreation ? '12' : '8'} col-md-${isCreation ? '12' : '8'} col-sm-12`}>
          <div className={`${cx.BannerOuter}`}>
            <div className={cx.left}>
              <h3>Venture Verse</h3>
              <p>
                Step into the Venture Verse and explore a dynamic universe of startups, from <strong>raw ideas to scaling ventures.</strong>
              </p>
              <div className={cx.buttonsContainer}>
                {!isCreation && (
                  <div className={cx.buttonInner}>
                    <button onClick={handleCreate} className={cx.dynamicButton} disabled={loading}>{!myVenture ? "Post Your Venture" : myVenture?.draft ? 'Publish Your Venture' : 'View Your Venture'}</button>
                    <button className={`${cx.dynamicParticipantButton} ${cx.mvpbutton}`} onClick={() => handleNavigateToMVP('first')}>
                      {mvpLoading && mvpLoading === 'first' ? <Loader size='22px' margin={'0 auto'}/> : "Build your MVP"}
                    </button>
                  </div>
                )
                }
                {!isCreation &&
                  <button className={cx.dynamicParticipantButton} onClick={handleNavigateToDemoDay}>Participate in Demo Day</button>
                }
              </div>
            </div>
            {!isCreation && <div className={cx.right}>
              <img src={ventureverselightning} alt="ligtning" />
            </div>}
          </div>
        </div>
        {!isCreation && (
          <div className="col-xl-4 col-md-4 col-sm-12 position-relative">
            {visibleSide === 0 &&
              <div className={`${cx.venturesListedOuter} `}>
                <div className={`${cx.listInnter}`}>
                  <p className={`${cx.minWidth}`}>Ventures Listed <span><img src={flashicon} alt="flash" /> {totalVentures}</span></p>
                  <p >Seeking Co-founder <span><img src={usernew} alt="user" /> {totalSeekingCoFounder}</span></p>
                </div>
                <div className={`${cx.listInnter}`}>
                  <p className={`${cx.minWidth}`}>Hiring Team <span><img src={briefcase} alt="briefcase" /> {totalHiringTeams}</span></p>
                  <p>Total Feedbacks <span><img src={venturechat} alt="feedback" /> {totalFeedback}</span></p>
                </div>
              </div>}
            {visibleSide === 1 && <div className={`${cx.venturesListedOuter} ${cx.desktop}`}>
              <div className={`${cx.participateTop}`}>
                <h2>Launch your Venture with us </h2>
                <p>Get Noticed. Get Funded.</p>
              </div>
              <div className={`${cx.participateBottom}`}>
                <button onClick={handleNavigateToDemoDay}>
                  <svg width="20" height="20" style={{ marginRight: '4px' }} viewBox="0 0 29 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M23.5114 0.818645L23.8883 0.865943C24.8845 1.0034 26.2029 1.18816 26.9493 1.93606C27.5613 2.5465 27.7963 3.53976 27.9367 4.42659L28.0195 4.99713C28.2057 6.34216 28.2545 8.10401 27.9367 10.061C27.31 13.9231 25.254 18.5317 20.0911 22.0998C20.0631 22.3777 20.0616 22.6585 20.0675 22.9393L20.0823 23.3591C20.1059 24.005 20.1296 24.6509 19.9492 25.2776C19.6684 26.2531 18.6678 26.8961 17.7322 27.3573L17.274 27.5745L16.6827 27.8347C15.5771 28.3047 14.0843 28.7865 13.1487 27.8494C12.587 27.2893 12.3564 26.4675 12.1687 25.6501L12.0993 25.3441C12.0198 24.9581 11.9212 24.5763 11.8036 24.2001C11.7297 23.9833 11.6499 23.7641 11.5642 23.5424C11.4699 23.6582 11.3697 23.7692 11.2642 23.8749C10.7542 24.3849 9.99302 24.7411 9.36632 24.9909C8.68198 25.2614 7.90747 25.4978 7.19062 25.693L6.82258 25.7905L6.11754 25.9664L5.47902 26.1142L4.71486 26.2768L4.23745 26.3699C3.99935 26.414 3.75409 26.3995 3.52284 26.3277C3.29159 26.2558 3.08129 26.1288 2.91006 25.9576C2.73884 25.7864 2.61183 25.5761 2.54001 25.3448C2.46818 25.1136 2.45368 24.8683 2.49777 24.6302L2.62488 23.9932L2.8525 22.9615L3.03578 22.2077L3.17472 21.6756C3.36982 20.9602 3.60631 20.1857 3.87828 19.5028C4.12659 18.8747 4.48281 18.1135 4.99274 17.6035L5.11098 17.4897L5.01639 17.4513C4.76375 17.3553 4.50789 17.2681 4.24927 17.1897L3.83985 17.064C2.81407 16.7536 1.71735 16.4196 1.03596 15.7367C0.208249 14.9105 0.487603 13.6527 0.88668 12.6062L1.04927 12.2012L1.31088 11.61L1.52816 11.1518C1.98931 10.2176 2.63227 9.21699 3.60779 8.93616C4.12511 8.78836 4.66313 8.77949 5.2041 8.79427L5.52927 8.80462C5.952 8.8194 6.37325 8.83565 6.78563 8.79575C10.3537 3.6314 14.9623 1.57541 18.8244 0.948715C20.3738 0.694599 21.9503 0.650847 23.5114 0.818645ZM9.00863 19.5531C8.77608 19.3807 8.49804 19.2804 8.20901 19.2647C7.91998 19.2489 7.63268 19.3184 7.38276 19.4644L7.22018 19.5738L7.08272 19.6965L6.89796 19.93C6.51366 20.4857 6.29491 21.2543 6.12493 21.9727L5.9653 22.6644L5.88992 22.9792L6.17223 22.9112L6.79006 22.7693C7.64438 22.5698 8.59182 22.3111 9.17417 21.7864C9.42738 21.5334 9.58013 21.197 9.60406 20.8398C9.62798 20.4826 9.52145 20.1288 9.30424 19.8443L9.18304 19.7053L9.14757 19.6713L9.00863 19.5531ZM19.6256 9.24508C19.3511 8.97052 19.0252 8.75271 18.6666 8.60408C18.308 8.45546 17.9236 8.37893 17.5354 8.37886C17.1471 8.37879 16.7627 8.45518 16.404 8.60368C16.0453 8.75218 15.7194 8.96988 15.4449 9.24434C15.1703 9.5188 14.9525 9.84465 14.8039 10.2033C14.6552 10.5619 14.5787 10.9463 14.5786 11.3345C14.5786 11.7227 14.655 12.1072 14.8035 12.4659C14.952 12.8246 15.1697 13.1505 15.4441 13.425C15.9984 13.9795 16.7503 14.2911 17.5343 14.2913C18.3183 14.2914 19.0703 13.9801 19.6248 13.4258C20.1793 12.8715 20.4909 12.1196 20.491 11.3356C20.4912 10.5515 20.1798 9.79957 19.6256 9.24508Z" fill="#FE8C00" />
                  </svg>
                  Participate in Demo Day
                </button>
              </div>
            </div>}
            {visibleSide === 1 && <div className={`${cx.venturesListedOuter} ${cx.mobile}`}>
              <div className={`${cx.participateTop}`}>
                <h2>Build your MVP </h2>
                <p>Get <strong>15% off</strong> on AppOpen, exclusively for htraction users.</p>
              </div>
              <div className={`${cx.participateBottom}`}>
                <button onClick={() => handleNavigateToMVP('second')}>
                  {mvpLoading && mvpLoading === 'second' ? <Loader size='22px' margin={'0 auto'}/> : <>
                    <svg width="20" height="20" style={{ marginRight: '4px' }} viewBox="0 0 29 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path fillRule="evenodd" clipRule="evenodd" d="M23.5114 0.818645L23.8883 0.865943C24.8845 1.0034 26.2029 1.18816 26.9493 1.93606C27.5613 2.5465 27.7963 3.53976 27.9367 4.42659L28.0195 4.99713C28.2057 6.34216 28.2545 8.10401 27.9367 10.061C27.31 13.9231 25.254 18.5317 20.0911 22.0998C20.0631 22.3777 20.0616 22.6585 20.0675 22.9393L20.0823 23.3591C20.1059 24.005 20.1296 24.6509 19.9492 25.2776C19.6684 26.2531 18.6678 26.8961 17.7322 27.3573L17.274 27.5745L16.6827 27.8347C15.5771 28.3047 14.0843 28.7865 13.1487 27.8494C12.587 27.2893 12.3564 26.4675 12.1687 25.6501L12.0993 25.3441C12.0198 24.9581 11.9212 24.5763 11.8036 24.2001C11.7297 23.9833 11.6499 23.7641 11.5642 23.5424C11.4699 23.6582 11.3697 23.7692 11.2642 23.8749C10.7542 24.3849 9.99302 24.7411 9.36632 24.9909C8.68198 25.2614 7.90747 25.4978 7.19062 25.693L6.82258 25.7905L6.11754 25.9664L5.47902 26.1142L4.71486 26.2768L4.23745 26.3699C3.99935 26.414 3.75409 26.3995 3.52284 26.3277C3.29159 26.2558 3.08129 26.1288 2.91006 25.9576C2.73884 25.7864 2.61183 25.5761 2.54001 25.3448C2.46818 25.1136 2.45368 24.8683 2.49777 24.6302L2.62488 23.9932L2.8525 22.9615L3.03578 22.2077L3.17472 21.6756C3.36982 20.9602 3.60631 20.1857 3.87828 19.5028C4.12659 18.8747 4.48281 18.1135 4.99274 17.6035L5.11098 17.4897L5.01639 17.4513C4.76375 17.3553 4.50789 17.2681 4.24927 17.1897L3.83985 17.064C2.81407 16.7536 1.71735 16.4196 1.03596 15.7367C0.208249 14.9105 0.487603 13.6527 0.88668 12.6062L1.04927 12.2012L1.31088 11.61L1.52816 11.1518C1.98931 10.2176 2.63227 9.21699 3.60779 8.93616C4.12511 8.78836 4.66313 8.77949 5.2041 8.79427L5.52927 8.80462C5.952 8.8194 6.37325 8.83565 6.78563 8.79575C10.3537 3.6314 14.9623 1.57541 18.8244 0.948715C20.3738 0.694599 21.9503 0.650847 23.5114 0.818645ZM9.00863 19.5531C8.77608 19.3807 8.49804 19.2804 8.20901 19.2647C7.91998 19.2489 7.63268 19.3184 7.38276 19.4644L7.22018 19.5738L7.08272 19.6965L6.89796 19.93C6.51366 20.4857 6.29491 21.2543 6.12493 21.9727L5.9653 22.6644L5.88992 22.9792L6.17223 22.9112L6.79006 22.7693C7.64438 22.5698 8.59182 22.3111 9.17417 21.7864C9.42738 21.5334 9.58013 21.197 9.60406 20.8398C9.62798 20.4826 9.52145 20.1288 9.30424 19.8443L9.18304 19.7053L9.14757 19.6713L9.00863 19.5531ZM19.6256 9.24508C19.3511 8.97052 19.0252 8.75271 18.6666 8.60408C18.308 8.45546 17.9236 8.37893 17.5354 8.37886C17.1471 8.37879 16.7627 8.45518 16.404 8.60368C16.0453 8.75218 15.7194 8.96988 15.4449 9.24434C15.1703 9.5188 14.9525 9.84465 14.8039 10.2033C14.6552 10.5619 14.5787 10.9463 14.5786 11.3345C14.5786 11.7227 14.655 12.1072 14.8035 12.4659C14.952 12.8246 15.1697 13.1505 15.4441 13.425C15.9984 13.9795 16.7503 14.2911 17.5343 14.2913C18.3183 14.2914 19.0703 13.9801 19.6248 13.4258C20.1793 12.8715 20.4909 12.1196 20.491 11.3356C20.4912 10.5515 20.1798 9.79957 19.6256 9.24508Z" fill="#FE8C00" />
                    </svg>
                    Start Building Now
                  </>}
                </button>
              </div>
            </div>}
            {!isCreation && (
              <div className={cx.navDotsContainer}>
                {[0, 1].map((side) => (
                  <span
                    key={side}
                    className={`${cx.dot} ${visibleSide === side ? cx.activeDot : ''}`}
                    onClick={() => setVisibleSide(side)}
                  />
                ))}
              </div>
            )}
          </div>
        )}
      </div >
      <ConfirmModal
        title=""
        description={<p style={{ display: 'flex', alignItems: 'center', flexDirection: 'column', margin: '0' }}>
          <span>To enjoy all the features of <span style={{ color: '#fa4616' }}>htraction</span> </span>
          <span><span style={{ color: '#fa4616' }}>Sign in</span> to Continue</span>
        </p>}
        openConfirmModal={show}
        onClose={() => setShow(false)}
        onSubmit={handleNavigate}
        submitText="Sign in"
        type="confirm"
      />
    </>
  );
}

export default DemoDayBanner;
